import React from 'react';
import { Link } from 'react-router-dom';
import { heroData, logoCarousel } from '../data/mockData';

const HeroSection = () => {
  return (
    <section className="bg-[#F9FBF5] overflow-hidden">
      {/* Hero Content */}
      <div className="max-w-[1121px] mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-8">
        {/* H1 - left aligned, 24px, weight 400 */}
        <h1 className="text-[#0A3900] text-[18px] lg:text-[24px] font-normal leading-[1.25] tracking-[-0.011em] mb-2">
          {heroData.subtitle}
        </h1>
        {/* Hero big headings - staggered left/right */}
        <div>
          <h2 className="text-[#082900] text-[56px] sm:text-[72px] lg:text-[106px] font-light leading-[1.075] not-italic">
            {heroData.headingLine1}
          </h2>
          <h2 className="text-[#082900] text-[56px] sm:text-[72px] lg:text-[106px] font-light leading-[1.065] not-italic lg:text-right">
            {heroData.headingLine2}
          </h2>
        </div>
        {/* Subheading - centered, 24px, weight 400 */}
        <div className="max-w-[570px] mx-auto mt-8 lg:mt-12">
          <p className="text-[#0A3900] text-[18px] lg:text-[24px] font-normal leading-[1.25] tracking-[-0.011em] text-center">
            {heroData.description}
          </p>
        </div>
        {/* CTA - centered, 18px, weight 400, normal case */}
        <div className="text-center mt-10 lg:mt-12">
          <Link
            to="/demo"
            className="inline-block px-8 py-4 bg-[#082900] text-[#F9FBF5] text-[16px] lg:text-[18px] font-normal tracking-[-0.011em] rounded-full hover:bg-[#0A3900] transition-colors duration-300"
          >
            Request a demo
          </Link>
        </div>
      </div>

      {/* Hero Video - TEMPORARY: Videos sourced as placeholders, replace before production */}
      <div className="max-w-[1121px] mx-auto px-6 lg:px-10 pb-12 lg:pb-16">
        <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '16/9' }}>
          {/* Poster image shown while video loads */}
          <img
            src={heroData.heroImage}
            alt="AI Recruiting Platform"
            className="absolute inset-0 w-full h-full object-cover"
            loading="eager"
          />
          {/* Desktop video */}
          <video
            className="absolute inset-0 w-full h-full object-cover hidden md:block"
            autoPlay
            muted
            playsInline
            loop
            preload="auto"
          >
            <source src={heroData.heroVideo} type="video/mp4" />
          </video>
          {/* Mobile video */}
          <video
            className="absolute inset-0 w-full h-full object-cover md:hidden"
            autoPlay
            muted
            playsInline
            loop
            preload="auto"
          >
            <source src={heroData.heroVideoMobile} type="video/mp4" />
          </video>
        </div>
      </div>

      {/* Logo Carousel */}
      <div className="pb-12 lg:pb-14 pt-8 lg:pt-12">
        <p className="text-center text-[#082900] text-[14px] lg:text-[15px] font-medium leading-[20px] mb-6">
          {logoCarousel.title}
        </p>
        <div className="relative overflow-hidden">
          <div className="logo-carousel-track flex items-center gap-16">
            {[...logoCarousel.logos, ...logoCarousel.logos, ...logoCarousel.logos].map((logo, i) => (
              <img
                key={i}
                src={logo.url}
                alt={logo.name}
                className="h-8 md:h-10 w-auto object-contain flex-shrink-0 opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                loading="lazy"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
